import { getPlanMonthlyPrice } from "./get-plan-monthly-price";
import { getPlanPriceSubtitle } from "./get-plan-price-subtitle";
import { Plan } from "../types/plans.types";
import { DatasetPlan } from "../types/datasets.types";

export const getPlanPriceInformation = (plan?: Plan | DatasetPlan, tier?: Plan) => {
  let price: number | string | undefined = plan?.monthlyPrice;
  const notAvailable = price == null || typeof price === "string";
  const isEnterprisePlan = tier?.id === "enterprise";
  if (!plan?.active) {
    return { priceSubtitle: "", monthlyPrice: "Not available", isNotAvailable: true, isEnterprisePlan };
  }
  
  price = notAvailable ? price || "Not available" : price;
  const isFreePlan = (plan as Plan)?.isFree || (plan as DatasetPlan)?.planId === "free";
  let type: "free" | "monthly" | "trial" | "enterprise" = isFreePlan ? "free" : ("monthly" as const);
  if (isEnterprisePlan) {
    type = "enterprise";
  }

  const priceSubtitle = getPlanPriceSubtitle(type);
  const monthlyPrice = isEnterprisePlan ? "Contact Us" : getPlanMonthlyPrice(price);
  return { priceSubtitle, monthlyPrice, isNotAvailable: monthlyPrice === 'Not available', isEnterprisePlan };
};
